//------------------------------------------------------ externos
//------------------------------------------------------ elementos
import MovimientoTraficoAccess from "../components/access/accessButtons/MovimientoTraficoAccess";
import RegistroAccess from "../components/access/RegistroAccess";
//------------------------------------------------------ funciones
import { useRealtime } from "../services/store";

/* Satelital registra EVENTOS, y nada más. Los accesos de Chofer, Tractor y
 * Furgón que estaban acá eran herencia del scaffold: satelital no da de alta
 * personas ni vehículos — eso vive en el padrón y en las secciones de cada
 * universo, con sus permisos. Un alta duplicada en una sección que no es la
 * dueña del dato es cómo se terminan cargando dos veces las cosas. */
const Satelital = () => {
  console.log("[Render] Seccion Satelital");
  const eventos = useRealtime("eventosSatelital");

  return (
    <section className="section">
      <div className="sections-options-group">
        <div className="section-options-row-right">
          <div className="sections-options-row">
            <RegistroAccess
              filtro={"satelital"}
              title={"Registro Satelital"}
              data={eventos}
              editable={false}
            />
          </div>
          <div className="sections-options">
            <MovimientoTraficoAccess
              type={"traficoSatelital"}
              title={"REGISTRAR NUEVO EVENTO"}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Satelital;
